import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible } from '@tfecom-thermofisher/react-komodo-design';

import {
  ALL_WELL_VOL_OPTIONS,
  SYNTHESIS_SCALE_OPTIONS,
  WELL_FIELD,
  SCALE_FIELD,
  PURIFICATION_OPTIONS,
  BUFFER_OPTIONS,
  BUFFER_FIELD,
  PURIFICATION_FIELD,
  ALL_SHIPPING_FORMAT_OPTIONS,
  SHIPPING_FORMAT_FIELD,
  QUALITY_TESTING_OPTIONS,
  QUALITY_TESTING_FIELD,
  COUNTRY_CODE_JAPAN,
  AMPLISEQ_PLATE_SIZE_OPTIONS_MSG,
  PLATE_SIZES,
  SECOND_PRIORITY_COUNTRIES,
  DESIGN_ID
} from 'src/constants/forms';
import { Message } from 'src/core/components';
import { DetailRow } from 'src/components';
import { SummarySectionTitle } from 'src/components/OligoDNA/components/Summary/components';
import { getCountryCode } from 'src/utils';
import messages from 'src/components/OligoDNA/components/Summary/messages';
import { DnaOligo } from 'src/models';

const PlateSizeDetailsComponent = ({
  details,
  showTitle,
  onEditClick,
  dnaType
}) => (
  <>
    <Visible when={showTitle}>
      <SummarySectionTitle
        titleMessage={messages.plateSizeDetailsSubTitle}
        onEditClick={onEditClick}
      />
      <Spacer bottom={8} />
    </Visible>
    <DetailRow
      label={messages.plateSize}
      value={(
        <Visible when={!!details?.plateSize?.value}>
          <Visible when={(details?.plateSize?.value === PLATE_SIZES.SIZE_96) && dnaType}>
            <Message
              message={{
                ...AMPLISEQ_PLATE_SIZE_OPTIONS_MSG[dnaType],
                values: { totalOligos: `${details?.plateSize?.value} ` },
              }}
            />
          </Visible>
          <Visible when={(details?.plateSize?.value === PLATE_SIZES.SIZE_384) || !dnaType}>
            <Message
              message={{
                ...messages.wells,
                values: { totalOligos: `${details?.plateSize?.value} ` },
              }}
            />
          </Visible>
        </Visible>
      )}
      dots
    />
    <Spacer bottom={8} />
    <DetailRow
      label={messages.well}
      value={
        ALL_WELL_VOL_OPTIONS.find((item) => item.value === details[WELL_FIELD]?.value)
          ?.label
      }
      dots
    />
    <Spacer bottom={8} />
    <DetailRow
      label={messages.scale}
      value={
        SYNTHESIS_SCALE_OPTIONS.find(
          (item) => item.value === details[SCALE_FIELD]?.value
        )?.label
      }
      dots
    />
    <Spacer bottom={8} />
    <DetailRow
      label={messages.purification}
      value={
        PURIFICATION_OPTIONS.find(
          (item) => item.value === details[PURIFICATION_FIELD]?.value
        )?.label
      }
      dots
    />
    <Spacer bottom={8} />
    <DetailRow
      label={messages.buffer}
      value={
        BUFFER_OPTIONS.find((item) => item.value === details[BUFFER_FIELD]?.value)
          ?.label
      }
      dots
    />
    <Visible when={getCountryCode() !== COUNTRY_CODE_JAPAN &&
     !SECOND_PRIORITY_COUNTRIES.includes(getCountryCode())}
    >
      <Spacer bottom={8} />
      <DetailRow
        label={messages.qualityTesting}
        value={
          QUALITY_TESTING_OPTIONS.find(
            (item) => item.value === details[QUALITY_TESTING_FIELD]?.value
          )?.label
        }
        dots
      />
    </Visible>
    <Spacer bottom={8} />
    <DetailRow
      label={messages.shippingFormat}
      value={
        ALL_SHIPPING_FORMAT_OPTIONS.find(
          (item) => item.value === details[SHIPPING_FORMAT_FIELD]?.value
        )?.label
      }
      dots
    />
    <Visible when={!!DnaOligo.getDNAType()}>
      <Spacer bottom={8} />
      <DetailRow
        label={messages.designId}
        value={
          details[DESIGN_ID]?.value
        }
        dots
      />
    </Visible>
  </>
);

PlateSizeDetailsComponent.propTypes = {
  details: PropTypes.object.isRequired,
  showTitle: PropTypes.bool,
  onEditClick: PropTypes.func,
  dnaType: PropTypes.string
};

export default PlateSizeDetailsComponent;
